import type { WizardFlowDefinition } from '@/modules/wizard/types/WizardFlowDefinition'

export const consultationRebookingFlow: WizardFlowDefinition = {
  steps: [{ id: 'consultation_rebooking' }],
}
